import React, { useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { NavBar } from 'apps/auth/components/common/Layout/NavBar/NavBar';
import { SearchBar } from 'apps/auth/components/form/components/SearchBar/SearchBar';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { isObject, toLowerCase } from 'apps/auth/helpers/utils';

const ModalSearchCountryList = (props) => {
    const [searchCountry, setSearchCountry] = useState('');
    const [itemsList, setItems] = useState(props.items);

    const onChange = (e) => {
        setSearchCountry(e.target.value);
        const term = e.target.value;
        const resultList = props.items.filter((item) => {
            return term === undefined || (item.name !== null && toLowerCase(item.name).indexOf(toLowerCase(term)) >= 0);
        });
        setItems(resultList);
    };

    return (
        <ModalComponent canCloseModal={false}>
            <>
                {isObject(props.items) &&
                    props.items.length > 0 &&
                    itemsList.map((country, i) => {
                        return (
                            <CountryItemPanel
                                key={i}
                                onClick={(e) => {
                                    props.doRequest(e, props.url, country);
                                }}
                                flagIconName={country.code.toLowerCase()}
                                countryName={country.name}
                                query={searchCountry}
                            />
                        );
                    })}
            </>
            <NavBar isSearchBar>
                <SearchBar
                    placeholder={props.searchLabel}
                    value={searchCountry}
                    onChange={onChange}
                    onCloseButtonClick={(e) => {
                        e.preventDefault();
                        props.toggleModal(false);
                    }}
                />
            </NavBar>
        </ModalComponent>
    );
};

const mapStateToProps = ({ messages }) => ({
    searchLabel: messages.pageMessages.searchByCountryLabel,
});

export default connect(mapStateToProps, { toggleModal })(ModalSearchCountryList);
